<template>
  <div class="flex">
    <svg-icon type="mdi" :path="path"></svg-icon>
    <!-- <FormatListChecks /> -->
  </div>
</template>

<script>
// import FormatListChecks from "vue-material-design-icons/FormatListChecks.vue"

import SvgIcon from '@jamescoyle/vue-icon';
import { mdiFormatListChecks } from "@mdi/js"

export default {
  name: "FormatListChecksIcon",
  components: {
    SvgIcon
    // FormatListChecks,
  },
  data() {
    return {
      path: mdiFormatListChecks,
    }
  }
}
</script>
